import * as React from 'react'

import { InlineFieldWrapper } from '~/components/field-wrapper/InlineFieldWrapper'
import { ValidationOptions } from '~/components/form/validation'
import { RadioButton } from '~/components/radio-button/RadioButton'

type RadioFieldProps = {
  className?: string
  defaultChecked?: boolean
  error?: string
  label: string
  validation?: ValidationOptions
} & React.ComponentProps<typeof RadioButton>

export const RadioField = ({
  className,
  label,
  value,
  ...remainingProps
}: RadioFieldProps) => (
  <InlineFieldWrapper className={className} label={label}>
    <RadioButton value={value} {...remainingProps} />
  </InlineFieldWrapper>
)

RadioField.displayName = 'RadioField'
